import styled from 'styled-components';
import { MOBILE, LARGE, TABLET } from '@minerva-analytics/pantheon';
import { RED, LIGHT_GRAY, WHITE, GRAY, LIGHT_RED } from '../../theme';

const SubscribeContainer = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;

  @media (max-width: ${LARGE}) {
    margin-bottom: 2.5rem;
  }
  @media (max-width: ${MOBILE}) {
    padding: 0;
    width: 100%;
    display: inline-block;
  }
`;

// Add any product specific styling here
const SubscribeFormTheme = {
  Input: `
    margin: 0;
    font-family: Inter, sans-serif;
    font-weight: bold;
    font-size: 18px;
    height: 58px;
    width: 468px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 6px;
    box-shadow: inset 0 0 6px 0 rgba(204,204,204,0.5);
    box-sizing: border-box;
    background-color: ${WHITE};

    ::placeholder {
      color: ${GRAY},
      font-weight: bold;
      font-family: Inter, sans-serif;
      letter-spacing: 0.68px;
      line-height: 38px;
    }
    @media (min-width: ${TABLET}) {
      margin-right: 15px;
    }
    @media (max-width: ${MOBILE}) {
      border-radius: 5px 0 0 5px;
      width: 100%;
      font-size: 16px;
    }
  `,
  Button: `
    width: 90px;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.5px;
    font-family: 'Roboto Bold';
    font-weight: light !important;
    height: 58px;
    border-radius: 6px;
    background-color: ${RED};
    :hover {
      background-color: ${LIGHT_RED};
      transition: 0.5s;
    }

    @media (max-width: ${MOBILE}) {
      border-radius: 0 5px 5px 0;
      max-width: 6rem;
      min-width: 5rem;
      font-size: 16px;
    }
  `,
};

export { SubscribeContainer, SubscribeFormTheme };
